// Import external
import { Injectable } from '@angular/core';

// Import internal
import { environment } from '@env/environment';

interface IncidentOneViewParameter {
    subject: string;
    description: string;
    project: string;
    type: string;
}

interface InventoryOneViewParameter extends IncidentOneViewParameter {
    inventory: string;
}

@Injectable()
export class ExternalLinkService {

    public getCortexUrl(type: string, id: string) {
        return `${environment.cortexUrl}/synapps-redir?type=${type}&id=${id}`;
    }

    public getOneViewUrl(id: string) {
        return `${environment.oneviewUrl}/tickets/${id}`;
    }

    public getInventoryOneViewUrl({ inventory, ...options }: InventoryOneViewParameter) {
        return `${this.getIncidentOneViewUrl(options)}&inventory=${encodeURIComponent(inventory)}`;
    }

    public getIncidentOneViewUrl({ subject, description, project, type }: IncidentOneViewParameter) {
        const url = new URL('/tickets/create/-', environment.oneviewUrl);
        url.searchParams.set('subject', subject);
        url.searchParams.set('description', description);
        url.searchParams.set('projects', project);
        url.searchParams.set('type', type);

        return url.toString();
    }

}
